module.exports = "//public.getcloudapp.com/packs/media/images/icons-hidden-435013721800e72b5b6fd3fc4c438765.svg";